<template lang="pug">
fieldset-section(
  :large="large"
  :flex="flex"
)
  fieldset-input(
    ref="input"
    :wide="wide"
    :name="name"
    :id="name"
    :type="type"
    :value="value"
    :error="internalError"
    v-on="$listeners"
  )
  label.fieldset__label(
    v-if="label"
    :for="name"
  ) 
    span {{ label }}

  span.fieldset__error(
    v-if="internalError"
  ) {{ internalError }}

  slot

</template>

<script>
import FieldsetSection from './fieldset-section'
import FieldsetInput from './fieldset__input'

export default {
  name: 'fieldset-input',
  components: {
    FieldsetSection,
    FieldsetInput,
  },
  props: {
    flex: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  watch: {
    value(val) {
      if (val && this.internalError) {
        this.internalError = null
      }
    },
  },
  data() {
    return {
      internalError: null,
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    error(message) {
      this.internalError = message
    },
  },
}
</script>

<style lang="sass">
.fieldset__input
  &.--wide
    width: 100%
</style>
